import {Props as SelectProps} from 'react-select/src/Select';
import {Select} from '../../Select';
import React, {memo} from 'react';

const typedMemo: <T>(c: T) => T = memo;

export const SettingSelectComponent = typedMemo(
    function SettingSelectComponent<T>({label, ...restProps}: SelectProps<T> & { label: string }) {

        return (
            <div className='line'>
                <div className='left'>
                    <span>{label}</span>
                </div>
                <div className='right'>
                    <div className='select-box'>
                        <Select {...restProps}/>
                    </div>
                </div>
            </div>
        );
    },
);
